import PropTypes from 'prop-types';
import { useMemo } from 'react';
// material
import { CssBaseline } from '@material-ui/core';
import { ThemeProvider, createTheme, StyledEngineProvider } from '@material-ui/core/styles';
import { indigo, blue, purple, grey } from '@material-ui/core/colors';
//
import shape from './shape';
import palette from './palette';
import typography from './typography';
import breakpoints from './breakpoints';
import GlobalStyles from './globalStyles';
import componentsOverride from './overrides';
import shadows, { customShadows } from './shadows';

// ----------------------------------------------------------------------

ThemeConfig.propTypes = {
  children: PropTypes.node
};

export default function ThemeConfig({ children }) {
  const themeOptions = useMemo(
    () => ({
      palette: {
        primary: {
          main: indigo[600]
        },
        background: {
          default: grey[100]
        },
        darkblack: {
          default: '#00000'
        }
      },
      props: {
        MuiTextField: {
          InputLabelProps: {
            shrink: true
          }
        }
      },
      shape,
      typography,
      breakpoints,
      shadows,
      customShadows,
      overrides: {
        MuiInputLabel: {}
      }
    }),
    []
  );

  const theme = createTheme(themeOptions);
  theme.components = componentsOverride(theme);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalStyles />
        {children}
      </ThemeProvider>
    </StyledEngineProvider>
  );
}
